const DependentStatus = {
	active: "ACTIVE",
	inactive: "INACTIVE",
	removed: "REMOVED"
};

export const DEPENDENT_STATUS = DependentStatus;
